export default __webpack_public_path__ + "static/earn-recognition-illustration-light-e59370a0b8c943b7e3cd81a7417ea344.svg";